module.exports = __webpack_public_path__ + "static/img/6en.4261685.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/realme/6en.png
// module id = ISFO
// module chunks = 0